require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var _default = function _default() {
  return _react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50"
  }, _react["default"].createElement("path", {
    d: "M25 2C12.316 2 2 12.316 2 25a22.95 22.95 0 0 0 2.965 11.29l-2.93 10.44c-.094.344 0 .711.246.965a.996.996 0 0 0 .957.278l10.899-2.7A23.026 23.026 0 0 0 25 48c12.684 0 23-10.316 23-23S37.684 2 25 2zm11.57 31.117c-.492 1.36-2.851 2.606-3.984 2.77-1.02.148-2.309.215-3.723-.23a35.526 35.526 0 0 1-3.367-1.227c-5.922-2.528-9.789-8.418-10.086-8.805-.293-.39-2.41-3.16-2.41-6.031 0-2.867 1.523-4.282 2.066-4.864.543-.585 1.18-.73 1.575-.73.394 0 .789.004 1.132.02.364.02.852-.137 1.329 1.003.492 1.168 1.675 4.036 1.82 4.329.148.293.246.632.05 1.023-.195.387-.292.633-.59.973-.296.34-.62.757-.886 1.02-.297.292-.601.609-.258 1.19.344.587 1.528 2.493 3.285 4.04 2.254 1.988 4.157 2.601 4.747 2.894.59.293.933.242 1.28-.144.345-.391 1.473-1.703 1.868-2.29.395-.581.785-.484 1.328-.288.543.19 3.445 1.601 4.035 1.894.59.293.985.438 1.133.68.148.242.148 1.41-.344 2.773zm0 0"
  }));
};

exports["default"] = _default;